import React, { useEffect, useState } from "react";
import moment from "moment";
import CustomDateRange from "./CustomDateRange";
import { formatNumber, useQuery } from "../../utils";
import { _fetchApi } from "../../redux/action/api";
import { CURRENCY } from "../../components/Tables2";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import { Button } from "reactstrap";
import { FaArrowLeft } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Card } from "@themesberg/react-bootstrap";
function MDAsRevenueCollectionReportView() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const query = useQuery();
  const date_from = query.get("date_from");
  const sector = query.get("sector");
  const date_to = query.get("date_to");
  const today = moment();
  const [dateRange, setDateRange] = useState({
    type: "daily",
    month: today.format("MM"),
    quarter: Math.ceil(today.format("MM") / 3).toString(),
    year: today.format("YYYY"),
    from: date_from || today.format("YYYY-MM-DD"),
    to: date_to || today.format("YYYY-MM-DD"),
  });
  const handleChangeDate = ({ target: { name, value } }) => {
    switch (name) {
      case "month":
        const monthStart = moment(`'${dateRange.year}-${value}-01'`).format(
          "YYYY-MM-DD"
        );
        const monthEnd = moment(`'${dateRange.year}-${value}'`)
          .endOf("month")
          .format("YYYY-MM-DD");

        setDateRange({
          ...dateRange,
          from: monthStart,
          to: monthEnd,
          month: value,
        });
        break;
      case "year":
        const yearStart = moment(`'${value}-01-01'`).format("YYYY-MM-DD");
        const yearEnd = moment(`'${value}-12'`)
          .endOf("year")
          .format("YYYY-MM-DD");

        setDateRange({
          ...dateRange,
          from: yearStart,
          to: yearEnd,
        });
        break;

      case "quarter":
        let startMonth, endMonth;
        let selectedQuarter = value;
        switch (selectedQuarter) {
          case "Q1":
            startMonth = 1;
            endMonth = 3;
            break;
          case "Q2":
            startMonth = 4;
            endMonth = 6;
            break;
          case "Q3":
            startMonth = 7;
            endMonth = 9;
            break;
          case "Q4":
            startMonth = 10;
            endMonth = 12;
            break;
          default:
            // Handle unexpected quarter values
            break;
        }
        const qStart = moment(`'${dateRange.year}-${startMonth}-01'`).format(
          "YYYY-MM-DD"
        );
        const qEnd = moment(`'${dateRange.year}-${endMonth}'`)
          .endOf("month")
          .format("YYYY-MM-DD");

        setDateRange({
          ...dateRange,
          from: qStart,
          to: qEnd,
          quarter: selectedQuarter,
        });
        break;
      case "from":
        setDateRange({
          ...dateRange,
          from: moment(value).format("YYYY-MM-DD"),
        });
        break;

      case "to":
        setDateRange({
          ...dateRange,
          to: moment(value).format("YYYY-MM-DD"),
        });
        break;
      default:
        break;
    }
    setDateRange((prevDateRange) => ({
      ...prevDateRange,
      [name]: value,
    }));
  };
  const history = useHistory();
  useEffect(() => {
    _fetchApi(
      `/rev-collection-report-history?date_from=${dateRange.from}&date_to=${dateRange.to}&sector=${sector}&query_type=Sector View Report`,
      (res) => {
        if (res.success) {
          setData(res.results);
        }
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        console.log(err);
      }
    );
  }, [dateRange.from, dateRange.to]);
  return (
    <Card style={{ margin: "5px" }}>
      <Card.Body>
      <Button
        className="btn btn-link"
        size="sm"
        onClick={() => history.goBack()}
      >
        <FaArrowLeft /> Go back
      </Button>
      <h4 className="py-3 text-center">{sector} REPORTs</h4>
      {/* {JSON.stringify({ date_from, sector, date_to })} */}
      <CustomDateRange
        type={dateRange.type}
        month={dateRange.month}
        quarter={dateRange.quarter}
        year={dateRange.year}
        from={dateRange.from}
        to={dateRange.to}
        handleChangeDate={handleChangeDate}
      />
      {/* {JSON.stringify(data)} */}
      <div className="text-right">
        <h4>
          <span>TOTAL {sector}: </span>
          <span>
            {CURRENCY}
            {formatNumber(
              data.reduce((it, id) => it + parseFloat(id.amount), 0)
            )}
          </span>
        </h4>
      </div>
      <table
        style={{ width: "100%", border: "1px solid black" }}
        className="table table-responsive  table-striped table-zebra  pt-0 table-bordered"
      >
        <thead>
          <tr>
            <th className="border-bottom  text-">Service Category</th>
            <th className="border-bottom text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr>
              <td className="text-" style={{ cursor: "pointer" }}>
                <Link
                  to={`${Routes.SectorReportByServiceCategory.path}?date_from=${dateRange.from}&service_category=${item.service_category}&date_to=${dateRange.to}&sector=${sector}`}
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  {item.service_category}
                </Link>
              </td>
              <td className="text-right">{formatNumber(item.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </Card.Body>
    </Card>
  );
}

export default MDAsRevenueCollectionReportView;
